import { useQuery } from "@tanstack/react-query";
import apiBolerplate from "utils/_helpers/apiBolerplate";



export function useDomainLogo(domain_name) {
  const { data: domainLogo, isLoading, error } = useQuery({
    queryKey: ["domainLogo", domain_name],
    queryFn: async () => {
      const res = await apiBolerplate({
        url: "/user/get_domain_logo",
        bodyData: {
          domain_name,
        },
        hideLoader: true,
        hideMsg: true,
      });
      return res?.result ? res.result : { before_login: null, after_login: null };
    },
    staleTime: Infinity, // Logo won't change often
    cacheTime: Infinity,
    enabled: !!domain_name, // Only run if domain_name exists
  });

  return { domainLogo, isLoading, error };
}